var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpathy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M38.3334 45H41.6667V25H38.3334V45ZM48.3334 40H51.6667V28.3333H48.3334V40ZM28.3334 38.3333H31.6667V28.3333H28.3334V38.3333ZM23.3334 70V57.46C20.1667 54.5711 17.7089 51.3244 15.96 47.72C14.2112 44.1156 13.3356 40.4156 13.3334 36.62C13.3334 29.2289 15.9256 22.9444 21.11 17.7667C26.2967 12.5889 32.5934 10 40 10C46.0045 10 51.4312 11.8278 56.28 15.4833C61.1267 19.1389 64.2712 23.8611 65.7134 29.65L69.1667 43.3267C69.3889 44.1711 69.2311 44.9389 68.6934 45.63C68.1556 46.3211 67.4378 46.6667 66.54 46.6667H60V57.95C60 59.43 59.4723 60.6967 58.4167 61.75C57.3634 62.8056 56.0967 63.3333 54.6167 63.3333H46.6667V70H43.3334V60H54.6167C55.2145 60 55.7056 59.8078 56.09 59.4233C56.4745 59.0389 56.6667 58.5478 56.6667 57.95V43.3333H65.6667L62.5 30.4167C61.2223 25.3189 58.4778 21.1967 54.2667 18.05C50.0623 14.9056 45.3067 13.3333 40 13.3333C33.5556 13.3333 28.0556 15.5889 23.5 20.1C18.9445 24.6111 16.6667 30.1 16.6667 36.5667C16.6667 39.8867 17.3478 43.0422 18.71 46.0333C20.07 49.0222 22 51.68 24.5 54.0067L26.6667 56V70H23.3334Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpathy);
export default __webpack_public_path__ + "static/media/empathy.3e7edced79ab46595735b4dc6f485e26.svg";
export { ForwardRef as ReactComponent };